import { InfoCircleIcon } from "@common/components/icons";
import Tooltip from "@common/components/Tooltip";
import { gtmPushData } from "@common/helpers/gtm";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import { ChangeEvent } from "react";
import { useForm } from "react-hook-form";
import { Event as HotjarEvent, hotjar } from "@modules/core/hotjar/types";
import {
  FilterAction,
  FilterActions,
  FilterKeys,
  VehicleFilter,
} from "../types/vehicleFilter";

type Props = {
  onUpdate(filterAction: FilterAction): void;
  vehicleFilters: VehicleFilter[];
};

const VehicleWarrantyFilter = ({ onUpdate, vehicleFilters }: Props) => {
  const { t } = useTranslation(["common", "vehicle"]);
  const { register } = useForm();
  const vehicleWarrantyFilter = vehicleFilters.find(
    (f) => f.key === FilterKeys.Warranty
  );

  const vehicleWarrantyFilterState = vehicleWarrantyFilter
    ? (vehicleWarrantyFilter.state as boolean)
    : null;

  const userModified = vehicleWarrantyFilter !== undefined;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      onUpdate({
        type: FilterActions.AddWarrantyFilter,
        payload: e.target.checked,
      });

      gtmPushData({
        event: "Filter",
        element: "Checkbox",
        descriptor: "Cars Under Warranty",
      });

      hotjar.event(HotjarEvent.WarrantyFilter);
    } else {
      onUpdate({
        type: FilterActions.RemoveWarrantyFilter,
        payload: e.target.checked,
      });
    }
  };

  return (
    <div className="w-full relative">
      <div className="w-full flex flex-col justify-center px-6 py-4 bg-white min-h-full border-b border-gray-50">
        <div className="py-[2px]">
          <span
            className={`${
              userModified ? "visible" : "invisible"
            } absolute xs:top-6 left-3 h-2 w-2 rounded-full inline-block bg-brinkPink `}
          />
          <div className={classNames("flex items-center w-full")}>
            <div className="flex-1">
              <label className="flex items-center justify-between text-text-light-100 body-3">
                <Tooltip
                  content={
                    <div className="text-gray-500">
                      {t("vehicle:warranty_filter_tooltip")}
                    </div>
                  }
                  toolTipStyle="light"
                  arrowPlacement="top-left"
                  displayOn="hover"
                  toolTipClassName="w-56"
                >
                  <label
                    className="flex items-center"
                    htmlFor="carsUnderWarranty"
                  >
                    {t("common:cars_under_warranty")}
                    <InfoCircleIcon className="w-5 h-5 ml-2 text-primary-bold" />
                  </label>
                </Tooltip>
                <input
                  id="carsUnderWarranty"
                  type="checkbox"
                  className="h-4 w-4 -mt-[1px] mr-1 border-2 cursor-pointer border-text-light-200 text-primary-bold rounded-sm focus:outline-none focus:border-primary-bold focus:ring-0 focus:ring-offset-0"
                  {...register("carWarranty", {
                    onChange,
                  })}
                  checked={vehicleWarrantyFilterState || false}
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleWarrantyFilter;
